import { EventsName } from "../enums/eventsName";

/**
 * Maps document type to the corresponding event name for BigQuery logging
 * @param docType - The document type string
 * @returns The corresponding event name from EventsName enum, or undefined if no match found
 */
export const getEventNameByDocType = (docType: string): string | undefined => {
  const docTypeToEventMap: Record<string, string> = {
    nar_letter: EventsName.NAR_LETTER_UPLOAD,
    approval_letter: EventsName.APPROVAL_LETTER_UPLOAD,
    filled_form: EventsName.FILLED_FORM_UPLOAD,
    denial_letter: EventsName.DENIAL_LETTER_UPLOAD,
  };

  return docTypeToEventMap[docType];
};

/**
 * Maps document type to the corresponding event name for BigQuery logging
 * Falls back to AUTH_STATUS_SCREEN_SHOWN if no specific event is found
 * @param docType - The document type string
 * @returns The corresponding event name from EventsName enum
 */
export const getEventNameByDocTypeWithFallback = (docType: string): string => {
  return getEventNameByDocType(docType) || EventsName.AUTH_STATUS_SCREEN_SHOWN;
};
